import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f93217d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-width mt-3 mt-lg-0 min-vh-80" }
const _hoisted_2 = { class: "card card-form" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex position-absolute w-100 h-100 align-items-center justify-content-center",
  style: {"background-color":"rgba(255, 255, 255, 0.5)"}
}
const _hoisted_4 = { class: "d-block text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1))
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "card-title text-center fw-bold my-3" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "row my-3" }
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = {
  key: 0,
  class: "row my-3"
}
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = { class: "alert alert-danger" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-12 d-flex justify-content-center" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-12 d-flex justify-content-center" }
const _hoisted_21 = { class: "row my-3" }
const _hoisted_22 = { class: "col-12 my-3 col-md-12 d-flex justify-content-center" }
const _hoisted_23 = { class: "row my-3 row" }
const _hoisted_24 = { class: "col-12 my-3 col-md-12 d-flex justify-content-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row my-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center text-link" }, " Acceso exclusivo por invitación ")
], -1))
const _hoisted_26 = { class: "row my-3" }
const _hoisted_27 = { class: "col-md-12 d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneUpdateModal = _resolveComponent("PhoneUpdateModal")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FormEmail = _resolveComponent("FormEmail")!
  const _component_FormPassword = _resolveComponent("FormPassword")!
  const _component_AppButtonLogin = _resolveComponent("AppButtonLogin")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PhoneUpdateModal, {
      show: _ctx.showPhoneModal,
      onUpdate: _ctx.handlePhoneUpdate
    }, null, 8, ["show", "onUpdate"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.loading.status)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("h6", null, _toDisplayString(_ctx.loading.text), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.state.evento?.porInvitacion)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "btn btn-primary px-4 py-2",
                    style: {"height":"50px","width":"50px","display":"flex"},
                    to: { name: 'Home' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, { icon: ['fas', 'chevron-left'] })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.t('login.title')), 1),
              _createElementVNode("form", {
                onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_FormEmail, {
                      modelValue: _ctx.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                      required: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_FormPassword, {
                      modelValue: _ctx.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.error), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.state.evento?.porInvitacion)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_router_link, {
                            class: "nav-link text-link",
                            to: { name: 'Register' }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('login.register')), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_router_link, {
                            class: "nav-link text-link",
                            to: { name: 'Recovery' }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('restaurarPassword.title')), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_AppButtonLogin)
                        ])
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_AppButtonLogin)
                        ])
                      ]),
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_router_link, {
                            class: "nav-link text-link",
                            to: { name: 'Recovery' }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('restaurarPassword.title')), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ], 64))
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}